import { AxiosError } from 'axios';

import { BaseBusinessUnit } from '@xemplo/gp-types';

/**
 * Closed vocabulary of business-unit integration setting identifiers, owned by the
 * backend `IntegrationSettings` enum. Declaration order is the wire integer (0–4); the
 * API round-trips the member-name string (e.g. `"Payrun"`). See docs/adr/0003.
 */
export enum SettingName {
  Payrun = 'Payrun',
  Amendment = 'Amendment',
  KeypayReport = 'KeypayReport',
  FinalisePayrun = 'FinalisePayrun',
  SendPayslips = 'SendPayslips',
}

/** A single integration setting row as returned by GET (read model). */
export type BusinessUnitIntegrationSetting = {
  id: string;
  businessUnitId: string;
  payrollServiceProviderId: string;
  payrollConnectionId: number;
  settingName: string | null;
  isIntegrated: boolean;
  isEnabled: boolean;
  keypayReportUserId?: string | null;
};

/** A single integration setting in the PUT body (write model). */
export type IntegrationSettingsModel = {
  id?: string | null;
  settingName: string;
  isIntegrated: boolean;
  keypayReportUserId?: string | null;
};

/** PUT body — the complete set of settings (idempotent full replace). */
export type UpdateIntegrationSettingsPayload = IntegrationSettingsModel[];

/** Derived display/form shape — one boolean per known SettingName. */
export type IntegrationSettings = Partial<Record<SettingName, boolean>>;

/**
 * Query result: the raw GET rows (the write source of truth for a full-replace PUT)
 * plus a derived boolean-per-setting Record for display and form defaults.
 */
export type IntegrationSettingsData = {
  rows: BusinessUnitIntegrationSetting[];
  settings: IntegrationSettings;
};

/** Variables for the full-replace update: current form values + the GET rows to merge. */
export type UpdateIntegrationSettingsVariables = {
  values: IntegrationSettings;
  originalRows: BusinessUnitIntegrationSetting[];
};

export type UpdateIntegrationSettingsProps = {
  businessUnitId?: string | null;
};

export type DeleteBusinessUnitProps = {
  onSuccess?: (
    data: BaseBusinessUnit,
    variables: BaseBusinessUnit,
    onMutateResult: unknown,
    context: unknown,
  ) => unknown;
  onError?: (
    error: AxiosError<unknown>,
    variables: BaseBusinessUnit,
    context: unknown,
  ) => unknown;
};
